import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";

import * as moment from 'moment-timezone';

import {HelperService} from "app/lib/helper.service";
import {ModalService} from "app/views/modal/base_modal.component";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import { BillingService2 } from "../billing.service";
import { FilterParams } from "../../models/filter_form.model";
import { IStatResult } from "../../models/responce_result.model";

interface IOperationDataStats extends IStatResult {
	x: string[];
	y: string[]
}

@Component({
	selector: 'operation_data',
	templateUrl: './operation_data.component.html'
})
export class OperationDataComponent extends BaseComponent {
	public moment = moment;
	
	tableLoader: number = 100;
	years: number[] = [];
	months: string[] = [];
	columns: object[] = [];
	y: string[] = [];
	year: number = (new Date()).getFullYear();
	
	baseUrl: string = this.router.url.split('?')[0];
	
	addFilterParams = {
		userType: 'user',
		isBilling: true,
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated'],
		dateType: 'datePaid'
	};
	
	_isLiveData: string = 'true';
	_isByYears: string = 'false';
	
	constructor(
		public translate: TranslateService,
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public modalService: ModalService,
		public helper: HelperService,
		private router: Router,
		private route: ActivatedRoute,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		for (let yyyy = 2017; yyyy <= this.year; yyyy++) {
			this.years.unshift(yyyy);
		}
		
		this.route.queryParams.subscribe((params: any) => {
			this.year = params.year || moment().year();
			this._isLiveData = params.isLiveData || 'true';
			this._isByYears = params.isByYears || 'false';
			
			this.eventsService.broadcast('period-change', this.year);
		});
	}
	
	get isLiveData() {
		return this._isLiveData === 'true';
	}
	
	get isByYears() {
		return this._isByYears === 'true';
	}
	
	async getData() {
		this.columns = [];
		this.months = [];
		
		this.tableLoader = 0;
		
		const { y } = await this.service2.operationData.stats<IOperationDataStats>(
			<FilterParams>{ headersOnly: true, }
		).toPromise();
		this.y = y;
		
		if (this.isByYears) {
			let curYear = moment().year();
			
			let prevData = null;
			let i = 0;
			let arrDates = [];
			let arrMonths = [];
			
			for(let yyyy = curYear; yyyy >= 2017; yyyy--) {
				const tickDate = moment(`${yyyy}-01-01`, 'YYYY-MM-DD');
				arrDates.push(tickDate.format('YYYY-MM-DD 00:00:00'));
				arrMonths.push(yyyy);
				
				if (arrDates.length == 1) {
					let partDate = moment().startOf('day');
					partDate.add(-1, 'years');
					arrDates.push(partDate.format('YYYY-MM-DD 00:01:00'));
					arrMonths.push('-');
				}
			}
			
			const tick = 100 / arrDates.length;
			
			for (let oneYear of arrDates) {
				
				// TODO Какая-то дикая магия с параметрами, заменить на осмысленное
				const { stats } = await this.service2.operationData.stats(
					this.filter.getCopyFilterParams(
						<FilterParams>{
							oneYear: oneYear.replace(':01:', ':00:'),
							isNotFullYear: (oneYear.indexOf(':01:') > 0),
							isLiveData: this.isLiveData,
						}
					)
				).toPromise();
				
				let curData = stats[0] || {};
				let kList = Object.keys(curData);
				
				for (let k of kList) {
					let d = 0;
					if (i > 0) {
						d = (prevData[k] / curData[k] - 1) * 100.0;
					}
					
					if (prevData != null) {
						prevData[k + '_delta'] = d.toFixed(1);
						if (i == 0) {
							curData[k + '_delta'] = d.toFixed(1);
						}
					}
				}
				
				prevData = curData;
				
				// Когда текущий год, тогда запросов к серверу на одни больше,
				// потому что для текушего года и последнего месяца нужно сделать два запроса для тренда
				if (this.year != curYear || i != 1) {
					this.columns.push(curData);
					this.months.push(arrMonths[i]);
				}
				
				i++;
				
				this.tableLoader = Math.ceil(i * tick);
			}
		} else {
			let curYear = moment().year();
			let endDate = moment(`${this.year}-01-01`, 'YYYY-MM-DD');
			
			let tickDate = moment().startOf('month');
			if (this.year != curYear) {
				tickDate = moment(`${this.year}-12-01`, 'YYYY-MM-DD');
			}
			
			let prevData = null;
			let i = 0;
			let arrDates = [];
			let arrMonths = [];
			
			for (; tickDate >= endDate; tickDate.add(-1, 'months')) {
				arrDates.push(tickDate.format('YYYY-MM-DD 00:00:00'));
				arrMonths.push(tickDate.locale('ru').format('MMMM'));
				
				if (arrDates.length == 1 && this.year == curYear) {
					let partDate = moment().startOf('day');
					partDate.add(-1, 'months');
					arrDates.push(partDate.format('YYYY-MM-DD 00:01:00'));
					arrMonths.push('-');
				}
			}
			
			const tick = 100 / arrDates.length;
			
			for (let oneMonth of arrDates) {
				
				// TODO Какая-то дикая магия с параметрами, заменить на осмысленное
				const { stats } = await this.service2.operationData.stats(
					this.filter.getCopyFilterParams(
						<FilterParams> {
							oneMonth: oneMonth.replace(':01:', ':00:'),
							isNotFullMonth: (oneMonth.indexOf(':01:') > 0),
							isLiveData: this.isLiveData,
						}
					)
				).toPromise();
				
				let curData = stats[0] || {};
				let kList = Object.keys(curData);
				
				for (let k of kList) {
					let d = 0;
					if (i > 0) {
						d = (prevData[k] / curData[k] - 1) * 100.0;
					}
					
					if (prevData != null) {
						prevData[k + '_delta'] = d.toFixed(1);
						if (i == 0) {
							curData[k + '_delta'] = d.toFixed(1);
						}
					}
				}
				
				prevData = curData;
				
				// Когда текущий год, тогда запросов к серверу на одни больше,
				// потому что для текушего года и последнего месяца нужно сделать два запроса для тренда
				if (this.year != curYear || i != 1) {
					this.columns.push(curData);
					this.months.push(arrMonths[i]);
				}
				
				i++;
				
				this.tableLoader = Math.ceil(i * tick);
			}
		}
		
		this.tableLoader = 100;
	}
}
